module.exports = __webpack_public_path__ + "static/media/lv.de589f5c.svg";